
    import {computed, defineComponent, onMounted, reactive, toRefs} from 'vue';
    import apiTalent from "@/request/apis/api_talent";
    import PageUtil from "@/utils/page_util";
    import {message} from "ant-design-vue/es";
    import {IArticleItem} from "@/models/article_model";
    import ApiArticle from "@/request/apis/api_article";

    interface IState {
        list: any,
        visible: any,
        title: any,
        name: any,
        total: any,
        searches: any,
        editId: any,
        type: any,
        pid: any,
        sonData: any,
        visible2: any,
        visible3: any,
        position: any,
        title2: any,
        form: any,
        sn:any
    }


    export default defineComponent({
        name: 'salaryRange',
        components: {},
        setup() {
            let state: IState = reactive({
                visible: false,
                title: '',
                name: '',
                list: [],
                total: 0,
                searches: {
                    name: ''
                },
                editId: '',
                type: '',
                pid: '',
                sn:'',
                sonData: [],
                visible3: false,
                position: '',
                visible2: false,
                title2: '',
                form: {
                    first: undefined,
                    second: undefined,
                    name: ''
                }
            })
            const columns = [
                {
                    title: 'id',
                    dataIndex: 'id',
                    key: 'id',
                },
                {
                    title: '编码',
                    dataIndex: 'sn',
                    key: 'sn',
                },
                {
                    title: '分类名称',
                    dataIndex: 'name',
                    key: 'name',
                },
                {
                    title: '状态',
                    dataIndex: 'status',
                    key: 'status',
                },
                {
                    title: '添加时间',
                    dataIndex: 'create_time',
                    key: 'create_time',
                },
                {
                    title: '最后修改时间',
                    dataIndex: 'update_time',
                    key: 'update_time',
                },
                {
                    title: '操作',
                    dataIndex: 'action',
                    key: 'action',
                    width: 250,
                    align:'right'
                },
            ]

            const columns2 = [
                {
                    title: '编码',
                    dataIndex: 'sn',
                    key: 'sn',
                },
                {
                    title: '分类名称',
                    dataIndex: 'name',
                    key: 'name',
                },
                {
                    title: '状态',
                    dataIndex: 'status',
                    key: 'status',
                },

                {
                    title: '最后修改时间',
                    dataIndex: 'update_time',
                    key: 'update_time',
                },

                {
                    title: '操作',
                    dataIndex: 'action',
                    key: 'action',
                    width: 150
                },
            ]

            const add = () => {
                state.title = '新增分类'
                state.name = ''
                state.sn = ''
                state.editId = ''
                state.pid =""
                state.visible = true
                state.type = 1
            }

            const edit = (val) => {
                state.type = 2
                state.editId = val.id
                state.pid = val.pid
                state.sn = val.sn
                // state.editPid = val.pid
                state.name = val.name
                state.title = '编辑分类名称'
                state.visible = true
            }

            const edit2 = (val) => {
                state.type = 2
                state.editId = val.id
                state.name = val.name
                state.sn = val.sn
                state.visible2 = false
                state.title = '编辑分类名称'
                state.visible = true
            }
            const pagination = computed(() => ({
                total: state.total,
                current: state.searches.page,
                pageSize: state.searches.limit,
                showTotal: (total: any) => `共${total}条数据`,
                defaultPageSize: 10,
                // pageSizeOptions: ['5', '10', '15', '20'], // 可不设置使用默认
                showSizeChanger: true, // 是否显示pageSize选择
                showQuickJumper: true, // 是否显示跳转窗
            }));


            const handleTableChange = (pages: any) => {
                state.searches.limit = pages.pageSize
                state.searches.page = pages.current
                getList()
            };

            const getList = async () => {
                const params = {...state.searches}
                const res = await apiTalent.positionList(params)
                if (res && res.error_code == 0) {
                    const data: any = res.data
                    state.list = data
                }
            }

            const handleOk = async () => {
                if (state.type == 1 || state.type == 3) {
                    const params = {name: state.name, pid: state.pid,sn:state.sn,ids:state.pid + ','}
                    const res = await apiTalent.positionAdd(params)
                    if (res && res.error_code == 0) {
                        message.success(res.msg)
                        state.visible = false
                        await getList()
                    } else {
                        message.error(res.msg)
                    }
                }

                if (state.type == 2) {
                    const params = {name: state.name, id: state.editId, pid: state.pid,sn:state.sn}
                    const res = await apiTalent.positionEdit(params)
                    if (res && res.error_code == 0) {
                        message.success(res.msg)
                        state.visible = false
                        await getList()
                    } else {
                        message.error(res.msg)
                    }
                }
                state.visible2 = false
            }

            const handleOk2 = async () => {
                const params = {name: state.form.name, pid: state.form.second}
                const res = await apiTalent.positionAdd(params)
                if (res && res.error_code == 0) {
                    message.success(res.msg)
                    state.visible3 = false
                    await getList()
                } else {
                    message.error(res.msg)
                }
            }

            const onDel = async (val, val2) => {
                const params = {id: val.id, status: val2, pid: state.pid}
                const res = await apiTalent.positionStatus(params)
                if (res) {
                    message.destroy()
                    if (res.error_code === 0) {
                        message.success(res.msg)
                        await getList()
                        state.visible = false
                        state.visible2 = false
                        return
                    }
                    message.error(res.msg)
                }
            }

            const onSearch = () => {
                getList()
            }

            const onReset = () => {
                state.searches = {
                    name: ''
                }
                getList()
            }

            const seeSon = async (val) => {
                state.pid = val.id
                const params = {pid: val.id}
                const res = await apiTalent.positionChildrenList(params)
                if (res) {
                    if (res.error_code == 0) {
                        const data: any = res.data
                        state.sonData = data
                        state.visible2 = true
                    } else {
                        message.error(res.msg)
                    }
                }
            }

            const addSon = (val) => {
                state.visible = true
                state.title = "新增子分类"
                state.name = ''
                state.type = 3
                state.editId = ''
                state.sn = ''
                state.pid = val.id
            }

            const addPosition = () => {
                state.visible3 = true
                state.title = "新增职位"
                state.position = ""
                state.form = {
                    fisrt: undefined,
                    second: undefined,
                    name: ''
                }
            }

            const getSecond = async () => {
                // state.pid = state.form.first
                state.sonData = []
                state.form.second = undefined
                const params = {pid: state.form.first}
                const res = await apiTalent.positionChildrenList(params)
                if (res) {
                    if (res.error_code == 0) {
                        const data: any = res.data
                        state.sonData = data
                    } else {
                        message.error(res.msg)
                    }
                }
            }

            onMounted(() => {
                getList()
            })

            return {
                ...toRefs(state),
                columns,
                pagination,
                columns2,
                addSon,
                getSecond,
                handleOk,
                seeSon,
                onSearch,
                onReset,
                handleOk2,
                onDel,
                addPosition,
                edit,
                edit2,
                add,
                handleTableChange
            }
        }
    });
